import { render, staticRenderFns } from "./AssessmentPeriod.vue?vue&type=template&id=4e8bee6a"
import script from "./AssessmentPeriod.vue?vue&type=script&lang=js"
export * from "./AssessmentPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports